import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { inputCls } from "@/components/register/Fields";
import { PageHead } from "@/pages/admin/AdminLayout";
import { Table } from "@/pages/admin/Payments";

const blank = { email: "", name: "", role: "coach", password: "" };

export default function Staff() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState(blank);
  const load = () => api.get("/admin/staff").then((r) => setRows(r.data));
  useEffect(() => {
    load();
  }, []);
  const add = (e) => {
    e.preventDefault();
    api.post("/admin/staff", f).then(() => { toast.success("Staff member added — they'll set up MFA on first sign-in"); setF(blank); load(); }).catch((x) => toast.error(errMsg(x)));
  };
  const patch = (id, body, msg) => api.patch(`/admin/staff/${id}`, body).then(() => { toast.success(msg); load(); }).catch((x) => toast.error(errMsg(x)));
  return (
    <div data-testid="admin-staff">
      <PageHead title="Staff & roles" />
      <p className="text-sm text-slate-400 mb-6 max-w-2xl">Owner: everything incl. staff. Admin: players, medical, payments, refunds, settings. Coach: player list only (no contacts or medical).</p>
      <Table head={["Name", "Email", "Role", "MFA", "Last sign-in", ""]} testid="staff-table">
        {rows.map((s) => (
          <tr key={s.id} className={`border-b border-white/5 ${s.active ? "" : "opacity-50"}`}>
            <td className="px-4 py-3">{s.name}</td>
            <td className="px-4 py-3">{s.email}</td>
            <td className="px-4 py-3 capitalize">{s.role}</td>
            <td className="px-4 py-3">{s.totp_enabled ? "Enabled" : "Pending setup"}</td>
            <td className="px-4 py-3 text-slate-400">{fmtDate(s.last_login_at)}</td>
            <td className="px-4 py-3 text-xs space-x-3 whitespace-nowrap">
              {s.role !== "owner" && <button data-testid={`staff-toggle-${s.id}`} onClick={() => patch(s.id, { active: !s.active }, s.active ? "Deactivated" : "Reactivated")} className="accent-text">{s.active ? "Deactivate" : "Reactivate"}</button>}
              {s.role !== "owner" && s.totp_enabled && <button data-testid={`staff-reset-mfa-${s.id}`} onClick={() => patch(s.id, { reset_mfa: true }, "MFA reset")} className="text-slate-400">Reset MFA</button>}
            </td>
          </tr>
        ))}
      </Table>
      <form onSubmit={add} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 grid sm:grid-cols-5 gap-3 items-end" data-testid="staff-add-form">
        <input data-testid="staff-name" required placeholder="Name" className={inputCls} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <input data-testid="staff-email" required type="email" placeholder="Email" className={inputCls} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <select data-testid="staff-role" className={inputCls} value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })}><option value="coach">Coach</option><option value="admin">Admin</option></select>
        <input data-testid="staff-password" required minLength={10} type="password" placeholder="Temporary password (10+)" className={inputCls} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
        <button data-testid="staff-add" className="btn-primary !py-3">Add staff</button>
      </form>
    </div>
  );
}
